import { api } from "@data-phone/react-resource-server-auth"
import { useQuery } from "react-query"
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { setTagCategoriesSlice, TagCategory } from "../../store/slices/categories.slice";

const getCategoriesApi = async () => {
    const response = await api.get(`
        ${process.env.REACT_APP_CONTACT_API_URL}/category`)
    return response.data
}


export const useGetCategories = () => {
    const dispatch: AppDispatch = useDispatch();
    return useQuery<TagCategory[], Error>(
        "categories",
        getCategoriesApi, {
        onSuccess(data) {
            dispatch(setTagCategoriesSlice(data))
        },
        enabled: false
    }
    )
}

